export default __webpack_public_path__ + "static/media/wavesMobile.918e601d.png";